const API_KEY = '7ea6521b95d94e9dbbfa05af46b6436f';


export {API_KEY};
